import Type from './Type';
export function isILink(node) {
    return node.type === Type.Link;
}
export default isILink;    //# sourceMappingURL=isILink.js.map
